exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "svg.chart g.bar:hover{opacity:.7;cursor:pointer}svg.chart g.bar rect.label-border{fill:#8f8f8f;fill-opacity:0}svg.chart g.bar.hover rect.label-border{fill-opacity:.2}svg.chart g.bar.active rect.label-border{fill-opacity:.8;fill:#2a1600}svg.chart rect.bar-positive{fill:#4ae4a6}svg.chart rect.bar-negative{fill:#f96947}svg.chart text.label{fill:#fff;text-shadow:0 0 2px #000;font-family:Ubuntu}svg.chart g.bar.active text.label{fill:#e0c15a}svg.chart g.axis g.tick line,svg.chart g.axis path.domain{stroke:#888}.mg-histogram .axis text,.mg-x-axis text,.mg-y-axis text{font-size:.8em}.mg-markers text{fill:#888}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/chart.css
// module id = 535
// module chunks = 0